import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import css from '../cards/SellerCard.APP_TARGET.scss';
import { FormattedMessage as Translation } from 'react-intl';
import Button from 'Components/Button/Button';
import FollowButton from 'Components/Profile/FollowButton/FollowButton';
import Follows from 'Components/Profile/Follows/Follows';
import {
    userIsLogged,
    getLoggedUser
} from 'Selectors/user';

export const FollowSection = ({
    user,
    userIsLoggedIn,
    loggedUser
}) => {
    const showFollowButton = userIsLoggedIn && user.id !== loggedUser.id && user.id !== '';
    const showEditProfileButton = userIsLoggedIn && loggedUser.id && user.id === '';

    return (
        <div
            className={ css.network }
        >
            <Follows userId={ user.id } inLineFollowBtn={ true } />
            { showFollowButton
                && <div className={ css.followBtn }>
                    <FollowButton
                        userId={ user.id }
                        size="small"
                    />
                </div>
            }
            { showEditProfileButton
                && <Button
                    type="outline"
                    size="small"
                    fixed
                    href="/editProfile/info"
                    data-aut-id="editProfile"
                >
                    <Translation id="editProfile" defaultMessage="Edit Profile" />
                </Button>
            }
        </div>
    );
};

FollowSection.propTypes = {
    user: PropTypes.object.isRequired,
    userIsLoggedIn: PropTypes.bool,
    loggedUser: PropTypes.object
};

FollowSection.defaultProps = {
    user: {},
    userIsLoggedIn: false,
    loggedUser: {}
};

export const mapStateToProps = state => {
    return {
        userIsLoggedIn: userIsLogged(state),
        loggedUser: getLoggedUser(state)
    };
};

export default connect(mapStateToProps)(FollowSection);
